import React from 'react';

import styled from 'styled-components';
import { Divider1 } from 'styles/common';

import CompetencyList from './CompetencyList';
import WorkTowardsNewRole from './WorkTowardNewRole';

const Container = styled.div``;

const JobCompetencySection = ({
  levelUpId,
  jobFunction,
  jobRole,
  isCurrentRole,
  competencies,
  showWorkTowardsNewRole,
}) => (
  <Container>
    <Divider1 leftGutter={3} rightGutter={3} />
    <CompetencyList
      isCurrentRole={isCurrentRole}
      jobFunctionId={jobFunction.uuid}
      jobRoleId={jobRole.uuid}
      competencies={competencies}
      levelUpId={levelUpId}
    />
    {showWorkTowardsNewRole ? <WorkTowardsNewRole /> : null}
  </Container>
);

export default JobCompetencySection;
